
































import { ref, computed, defineComponent, toRefs, watch, nextTick } from '@vue/composition-api';
import YellowLightImg from '@tt4b/ttam-assets/src/images/creative/yellow-light.png';
import { PropType } from 'vue';
import { RecommendTargetDataWithLabel } from '../types';
import { flattenRecommendTargetData } from '../utils';

const name = 'ttam-recommend-interest-behavior-summary';

export default defineComponent({
  name,
  props: {
    visibleCount: {
      type: Number,
      default: undefined,
    },
    recommendData: {
      type: Object as PropType<RecommendTargetDataWithLabel>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { recommendData } = toRefs(props);

    const recommendFlattenOptions = computed(() => flattenRecommendTargetData(recommendData.value));

    const totalCount = computed(() => recommendFlattenOptions.value.length);
    const onMoreClick = () => {
      emit('click-more');
    };

    const tagsNode = ref<HTMLElement>();
    const tagsNodeArr = ref<HTMLElement[]>();
    const visibleTagCount = ref(5);

    const realVisibleTagCount = computed(() => props.visibleCount ?? visibleTagCount.value);

    /** 计算展示推荐标签数量 */
    function calcVisibleTagCount() {
      const tagGap = 8;
      let leftWidth = tagsNode.value?.offsetWidth ?? 0;
      const arr = tagsNodeArr.value ?? [];
      for (let index = 0; index < arr.length ?? 0; index++) {
        const curWidth = arr[index]?.offsetWidth ?? 0;
        const nextWidth = arr[index + 1]?.offsetWidth ?? 0;
        leftWidth = leftWidth - curWidth - tagGap;
        if (leftWidth - tagGap < nextWidth) {
          visibleTagCount.value = index + 1;
          break;
        }
      }
    }

    watch(totalCount, () => nextTick(() => calcVisibleTagCount()));

    return {
      name,
      YellowLightImg,
      totalCount,
      recommendFlattenOptions,
      tagsNode,
      tagsNodeArr,
      realVisibleTagCount,
      onMoreClick,
    };
  },
});
